import { ref, onUnmounted } from 'vue';

export function useNowUTC() {
    const getUTC = () => Date.now() + new Date().getTimezoneOffset() * 60_000;

    const now = ref(getUTC());

    const tick = setInterval(() => {
        now.value = getUTC();
    }, 1000);

    onUnmounted(() => clearInterval(tick));

    return { now };
}
